var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSum123EmptyUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 24,
    viewBox: "0 0 57 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_845_20558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.814941 23.0137V0H31.4995V23.0137H0.814941ZM29.7391 21.9178L30.2177 17.2603H15.1037L14.9347 19.1781H17.433L17.159 21.9178L29.7391 21.9178Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_845_20558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41067 23.0137L5.66983 20.5479L11.8005 17.2603L12.146 13.9726L2.35253 4.93151L2.69808 1.64384H7.65672L7.8295 0H15.2675H22.7054L22.5327 1.64384H27.4913L27.1458 4.93151L15.4518 13.9726L15.1062 17.2603L20.5458 20.5479L20.2866 23.0137H12.8486H5.41067ZM8.31039 3.28767H5.00463L4.91824 4.10959L7.96484 6.57534L8.31039 3.28767ZM21.5334 3.28767H24.8392L24.7528 4.10959L21.1879 6.57534L21.5334 3.28767Z",
    fill: "#FFB800"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_845_20558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7737 3.34439e-05V0H42.4582V17.2603H29.783L29.614 19.1781H32.1122L31.8383 21.9178L42.4582 21.9178V23.0137H25.9088L26.7533 14.7947L17.2198 14.7946L17.3062 13.9726L29.0002 4.93154L29.3457 1.64387H24.3871L24.5599 3.34439e-05H17.1219H11.7737ZM11.7737 14.7946L13.9141 14.7946L14.0005 13.9726L11.7737 11.9169V14.7946Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_845_20558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0872 23.0137L20.3463 20.5479L26.477 17.2603L26.8225 13.9726L17.029 4.93151L17.3746 1.64384H22.3332L22.506 0H29.944H37.3819L37.2092 1.64384H42.1678L41.8223 4.93151L30.1283 13.9726L29.7827 17.2603L35.2223 20.5479L34.9631 23.0137H27.5252H20.0872ZM22.9869 3.28767H19.6811L19.5948 4.10959L22.6414 6.57534L22.9869 3.28767ZM36.21 3.28767H39.5157L39.4293 4.10959L35.8644 6.57534L36.21 3.28767Z",
    fill: "#D9D7CF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_845_20558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 0,
    width: 31,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.02 0V3.34439e-05H31.9162H39.3541L39.1813 1.64387H44.14L43.7944 4.93154L32.1005 13.9726L32.0141 14.7946L41 14.7947L40.1555 23.0137H56.7046V0H26.02ZM28.7083 14.7946L26.02 14.7946V11.4111L28.7947 13.9726L28.7083 14.7946Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_845_20558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3333 23.0137L34.5924 20.5479L40.7231 17.2603L41.0686 13.9726L31.2751 4.93151L31.6207 1.64384H36.5793L36.7521 0H44.1901H51.628L51.4553 1.64384H56.4139L56.0684 4.93151L44.3744 13.9726L44.0288 17.2603L49.4684 20.5479L49.2092 23.0137H41.7712H34.3333ZM37.233 3.28767H33.9272L33.8408 4.10959L36.8875 6.57534L37.233 3.28767ZM50.4561 3.28767H53.7618L53.6754 4.10959L50.1105 6.57534L50.4561 3.28767Z",
    fill: "#E77238"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8904 17.6687L17.1085 15.5357H19.8233L20.1384 12.6028H22.4168L22.1017 15.5357H24.7923L24.5741 17.6687H21.8836L21.5685 20.6016H19.29L19.6051 17.6687H16.8904Z",
    fill: "#798BB5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4109 17.6687L31.629 15.5357H34.3438L34.6589 12.6028H36.9374L36.6222 15.5357H39.3128L39.0946 17.6687H36.4041L36.089 20.6016H33.8105L34.1256 17.6687H31.4109Z",
    fill: "#798BB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum123EmptyUpdated);
export default __webpack_public_path__ + "static/media/sum-1-2-3-empty-updated.1062ce461b033aa4d717486adb6492ec.svg";
export { ForwardRef as ReactComponent };